webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var XLSX = __webpack_require__("uXZL");
var _ = __webpack_require__("M4fF");
var filesaver = __webpack_require__("j1LZ");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DIANA',
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var erhjson;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch('https://dioedb.dioe.at/restapi/getAntworten?info=filter');

            case 2:
              erhjson = _context.sent;
              _context.next = 5;
              return erhjson.json();

            case 5:
              _this.erhebungen.filter = _context.sent.filter;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    erhebungenAutocompleatable: function erhebungenAutocompleatable() {
      if (this.erhebungen.filter[0]) {
        return this.erhebungen.filter[0].map(function (v, i) {
          return { text: v.Bezeichnung_Erhebung, value: i };
        });
      } else {
        return [];
      }
    },
    aufgabensetsAutocompleatable: function aufgabensetsAutocompleatable() {
      if (this.erhebungen.filter[0]) {
        return this.erhebungen.filter[0][this.erhebung_key].Aufgabensets.map(function (v, i) {
          return { text: v.Kuerzel + " | " + v.Name_Aset, value: v.pk };
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    loadAnswers: function loadAnswers(erh, set, length) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, resultEmpty, tagcount, i, j, jObject, tagKey, satzKey, headerstmp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.antwortenTable = [];
                console.log("awTable: ", _this2.antwortenTable);
                _this2.erhebung = erh;
                _this2.aufgabenset = set;
                _context2.next = 6;
                return fetch('https://dioedb.dioe.at/restapi/getAntworten?get=tbl_antworten&tagname=true&start=0&len=' + _this2.antworten + '&filter=erhebung:' + _this2.erhebung + ',aufgabenset:' + _this2.aufgabenset);

              case 6:
                result = _context2.sent;
                _context2.next = 9;
                return fetch('https://dioedb.dioe.at/restapi/getAntworten?get=tbl_antworten&tagname=true&start=0&len=0&filter=erhebung:' + _this2.erhebung + ',aufgabenset:' + _this2.aufgabenset);

              case 9:
                resultEmpty = _context2.sent;

                console.log("loadAnswers Params:", _this2.erhebung, _this2.aufgabenset, _this2.antworten);
                _context2.next = 13;
                return result.json();

              case 13:
                _this2.awjson.tbl_antworten = _context2.sent.tbl_antworten;
                _context2.next = 16;
                return resultEmpty.json();

              case 16:
                _this2.antworten_max = _context2.sent.tbl_antworten_count.all;
                tagcount = 0;
                jObject = {};
                tagKey = "";
                satzKey = "";
                headerstmp = [];


                if (_this2.sheetoption === 0) {
                  // ALLE TAGINFOS IN EINZELSPALTEN
                  for (i = 0; i < length; i++) {
                    tagcount = _this2.awjson.tbl_antworten[i].tbl_antwortentags_set.length;
                    _.forEach(_this2.awjson.tbl_antworten[i], function (value, key) {
                      if (i === 0) {
                        var headersobj = {};
                        if (key !== "ist_Satz") {
                          headersobj.text = _.clone(key);
                          headersobj.value = _.clone(key);
                          headerstmp.push(headersobj);
                        }
                      }

                      if (key === "ist_Satz") {
                        _.forEach(value, function (v, k) {
                          // console.log("header key: " + key + " | inner key: " + k + " | val: " + v)
                          satzKey = key + " " + k;
                          jObject[satzKey] = v;

                          var headersobj = {};
                          headersobj.text = _.clone(key) + " " + k;
                          headersobj.value = _.clone(key) + " " + k;
                          headerstmp.push(headersobj);
                        });
                      } else if (key === "tbl_antwortentags_set") {
                        for (j = 0; j < tagcount; j++) {
                          _.forEach(value[j], function (v, k) {
                            // console.log("header key: " + key + " | inner key: " + k + " | val: " + v)
                            tagKey = "Tag_" + (j + 1) + "_" + key + " " + k;
                            jObject[tagKey] = _.clone(v);
                          });
                        }
                      } else {
                        // console.log("header key: " + key + " | value: " + value)
                        jObject[key] = value;
                      }
                    });
                    // console.log("hobj i: " + i + " " + headersobj.text)
                    // every object that has been generated by the parsing process, gets written into an array which has the correct structure for the excel export
                    _this2.antwortenTable[i] = _.clone(jObject);
                    _this2.headers = _.clone(headerstmp);
                    // console.log("headers:", this.headers)
                  }
                } else if (_this2.sheetoption === 1) {
                  // TAGKÜRZEL
                  console.log("Download-Option: Tagkürzel");
                  tagKey = "Tags";

                  headerstmp = _.reduce(_this2.awjson.tbl_antworten[0], function (m, e, i) {
                    if (i === 'ist_Satz') {
                      m = m.concat(_.map(e, function (v, k) {
                        return { text: 'ist_Satz ' + k, value: 'ist_Satz ' + k };
                      }));
                    } else if (i === 'tbl_antwortentags_set' && _this2.sheetoption === 0) {
                      m = m.concat(_.map(e, function (v, k) {
                        return { text: 'tbl_antwortentags_set ' + k, value: 'tbl_antwortentags_set ' + k };
                      }));
                    } else {
                      m.push({ text: i, value: i });
                    }
                    return m;
                  }, []);
                  _this2.headers = headerstmp;
                  console.log({ headerstmp: headerstmp });

                  for (i = 0; i < length; i++) {
                    tagcount = _this2.awjson.tbl_antworten[i].tbl_antwortentags_set.length;
                    _.forEach(_this2.awjson.tbl_antworten[i], function (value, key) {
                      // if (i === 0) {
                      //   var headersobj = {}
                      //   if (key !== "ist_Satz") {
                      //     headersobj.text = _.clone(key)
                      //     headersobj.value = _.clone(key)
                      //     headerstmp.push(headersobj)
                      //   }
                      // }
                      if (key === "ist_Satz") {
                        _.forEach(value, function (v, k) {
                          satzKey = key + " " + k;
                          jObject[satzKey] = v;
                          // var headersobj = {}
                          // headersobj.text = _.clone(key) + " " + k
                          // headersobj.value = _.clone(key) + " " + k
                          // headerstmp.push(headersobj)
                        });
                      } else if (key === "tbl_antwortentags_set") {
                        var tagString = "";
                        for (j = 0; j < tagcount; j++) {
                          _.forEach(value[j], function (v, k) {
                            if (k === "id_Tag_Name") {
                              console.log("Tagname: ", v);
                              tagString += _.clone(v) + " ";
                            }
                          });
                          jObject["tbl_antwortentags_set"] = tagString;
                        }
                      } else {
                        // console.log("header key: " + key + " | value: " + value)
                        jObject[key] = value;
                      }
                    });
                    // every object that has been generated by the parsing process, gets written into afn array which has the correct structure for the excel export
                    _this2.antwortenTable[i] = _.clone(jObject);
                    _this2.tableanswers[i] = _.clone(jObject);
                    // this.headers = _.clone(headerstmp)
                    // console.log("String: ", tagString)
                  }
                } else {
                  // HIERARCHISCHE ABBILDUNG
                  console.log("coming soon!");
                }
                // this.antworten_max = this.awjson.tbl_antworten_count.all
                if (_this2.antwortenTable.length > 0) {
                  console.log("FILLED!");
                  _this2.table_filled = true;
                }
                if (_this2.complete) {
                  _this2.antworten = _this2.antworten_max;
                }
                console.log("length", _this2.antwortenTable.length);
                console.log("tableanswers", _this2.tableanswers);

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    clear: function clear() {
      this.complete = false;
      this.sheetoption = 0;
      this.erhebung = 0;
      this.erhebung_key = 0;
      this.aufgabenset = 0;
      this.antworten = 0;
      // this.awjson = {}
      this.antworten_max = 0;
      this.table_filled = false;
    },
    s2ab: function s2ab(s) {
      var buf = new ArrayBuffer(s.length); // convert s to arrayBuffer
      var view = new Uint8Array(buf); // create uint8array as viewer
      for (var i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
      } // convert to octet
      return buf;
    },
    setAnswerMax: function setAnswerMax() {
      console.log("setAnswerMax");
      this.antworten = this.antworten_max;
    },
    downloadXLSX: function downloadXLSX() {
      var wb = XLSX.utils.book_new();

      wb.items = {
        Title: "EH" + this.erhebung + "_AS" + this.aufgabenset + "_AW" + this.antworten + "_" + Date.now(),
        Subject: "DiÖ",
        Author: "DiÖ"
      };

      var wsname = "EH" + this.erhebung + "_AS" + this.aufgabenset + "_AW" + this.antworten + "_" + Date.now();
      console.log(wsname);
      var ws = XLSX.utils.json_to_sheet(this.antwortenTable);
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      filesaver.saveAs(new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }), 'DIANA_EH' + this.erhebung + '_AS' + this.aufgabenset + '_AW' + this.antworten + '.xlsx');
    },
    getSurvey: function getSurvey() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var jsonres;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.aufgabenset = 0;
                if (_this3.erhebung_key !== 0) {
                  _this3.erhebung = _this3.erhebungen.filter[0][_this3.erhebung_key].pk;
                  if (_this3.erhebungen.filter[0][_this3.erhebung_key].Aufgabensets[0].pk) {
                    if (_this3.erhebung_key !== 0) {
                      _this3.aufgabenset = _this3.erhebungen.filter[0][_this3.erhebung_key].Aufgabensets[0].pk;
                    }
                  }
                }
                _context3.next = 4;
                return fetch('https://dioedb.dioe.at/restapi/getAntworten?get=tbl_antworten&tagname=true&start=0&len=' + _this3.antworten + '&filter=erhebung:' + _this3.erhebung + ',aufgabenset:' + _this3.aufgabenset);

              case 4:
                jsonres = _context3.sent;
                _context3.next = 7;
                return jsonres.json();

              case 7:
                _this3.awjson.tbl_antworten_count = _context3.sent.tbl_antworten_count;

                console.log("MAX: ", _this3.awjson.tbl_antworten_count.all);
                _this3.antworten_max = _this3.awjson.tbl_antworten_count.all;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    geterh: function geterh() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var erhjson;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetch('https://dioedb.dioe.at/restapi/getAntworten?info=filter');

              case 2:
                erhjson = _context4.sent;
                _context4.next = 5;
                return erhjson.json();

              case 5:
                _this4.erhebungen.filter = _context4.sent.filter;

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },
  data: function data() {
    return {
      pagination: {
        sortBy: 'pk'
      },
      awjson: {
        tbl_antworten_count: {},
        tbl_antworten: []
      },
      antwortenTable: [],
      headers: [], // for v-data-table
      tableanswers: [], // for v-data-table
      erhebungen: { filter: [] },
      erhebung: 0,
      aufgabenset: 0,
      antworten: 0,
      antworten_max: 0,
      erhebung_key: 0,
      complete: false,
      table_filled: false,
      sheetoption: 0
    };
  }
});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7Ksl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JmJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Test__ = __webpack_require__("zXLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import App from './App'



 // Ensure you are using css-loader
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#test',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<Test/>',
  components: { Test: __WEBPACK_IMPORTED_MODULE_1__Test__["a" /* default */] }
});

/***/ }),

/***/ "TreG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"test"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
  }]
}));

/***/ }),

/***/ "dijw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23030190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("pm6a");
function injectStyle (ssrContext) {
  __webpack_require__("JmJt")
  __webpack_require__("7Ksl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23030190"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23030190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "paZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'test'
});

/***/ }),

/***/ "pm6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello pa-5"},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{attrs:{"id":"demo"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-autocomplete',{attrs:{"prepend-icon":"cloud_circle","label":"Erhebung","placeholder":"Start typing to Search","items":_vm.erhebungenAutocompleatable},on:{"input":_vm.getSurvey,"change":function($event){return _vm.loadAnswers(_vm.erhebung,_vm.aufgabenset,_vm.antworten)}},model:{value:(_vm.erhebung_key),callback:function ($$v) {_vm.erhebung_key=$$v},expression:"erhebung_key"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-autocomplete',{attrs:{"label":"Aufgabenset","prepend-icon":"filter_list","placeholder":"Start typing to Search","items":_vm.aufgabensetsAutocompleatable,"disabled":this.aufgabenset===0},on:{"change":function($event){return _vm.loadAnswers(_vm.erhebung,_vm.aufgabenset,_vm.antworten)}},model:{value:(_vm.aufgabenset),callback:function ($$v) {_vm.aufgabenset=$$v},expression:"aufgabenset"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-slider',{attrs:{"prepend-icon":"unfold_more","label":"Anzahl Antworten","thumb-color":"green","min":"0","max":this.antworten_max,"disabled":this.complete,"thumb-label":"always"},model:{value:(_vm.antworten),callback:function ($$v) {_vm.antworten=_vm._n($$v)},expression:"antworten"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-text-field',{attrs:{"type":"number","steps":"1","min":"0","max":this.antworten_max,"disabled":this.complete},model:{value:(_vm.antworten),callback:function ($$v) {_vm.antworten=_vm._n($$v)},expression:"antworten"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"Alle Antworten"},on:{"change":function($event){return _vm.setAnswerMax()}},model:{value:(_vm.complete),callback:function ($$v) {_vm.complete=$$v},expression:"complete"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-radio-group',{attrs:{"label":"Download Option:","row":""},model:{value:(_vm.sheetoption),callback:function ($$v) {_vm.sheetoption=$$v},expression:"sheetoption"}},[_c('v-radio',{attrs:{"name":"displayoption","label":"Alle Tag-Informationen","color":"red","value":0,"checked":"true"}}),_vm._v(" "),_c('v-radio',{attrs:{"name":"displayoption","label":"Nur Tagkürzel","color":"blue","value":1}}),_vm._v(" "),_c('v-radio',{attrs:{"name":"displayoption","label":"Hierarchische Abbildung","color":"green","disabled":true,"value":2}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[(this.table_filled)?_c('v-label',[_vm._v("Query-Vorschau")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"total-items":_vm.antworten_max,"item-key":"pk","headers":_vm.headers,"items":_vm.tableanswers},scopedSlots:_vm._u([{key:"items",fn:function(props){return _vm._l((_vm.headers),function(v,k){return _c('td',{key:k},[_vm._v("\n              "+_vm._s(props.item[v.value])+"\n            ")])})}}])})],1)],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.loadAnswers(_vm.erhebung,_vm.aufgabenset,_vm.antworten)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("refresh")]),_vm._v("ERZEUGE QUERY\n    ")],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":this.antworten===0},on:{"click":_vm.downloadXLSX}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("attach_file")]),_vm._v("EXPORTIERE XLSX\n    ")],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":false},on:{"click":_vm.clear}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("settings_backup_restore")]),_vm._v("RESET\n    ")],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b',[_vm._v("Erhebung:")]),_vm._v(" "+_vm._s(_vm.erhebung)+"   "),_c('b',[_vm._v("Aufgabenset:")]),_vm._v(" "+_vm._s(_vm.aufgabenset)+"   "),_c('b',[_vm._v("Anzahl Antworten:")]),_vm._v(" "+_vm._s(_vm.antworten)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Radio Option: "+_vm._s(_vm.sheetoption)+" ")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("API-Link:")]),_vm._v(" https://dioedb.dioe.at/restapi/getAntworten?get=tbl_antworten&tagname=true&start=0&len="),_c('font',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.antworten))]),_vm._v("&filter=erhebung:"),_c('font',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.erhebung))]),_vm._v(",aufgabenset:"),_c('font',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.aufgabenset))]),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('img',{attrs:{"src":"https://image.ibb.co/nLutoU/header.png","alt":"dianalyze-header","height":"75px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('i',[_c('br'),_vm._v("A few notes [2019-06-10]:"),_c('ul',[_c('li',[_vm._v("Query preview now active and working (after clicking the query button). Pagination currently not working, a fix is to be expected soon ;-)")]),_c('li',[_vm._v("XLSX export now active and working (some columns will be edited, especially tagsets)")]),_c('li',[_vm._v("third download options (hierarchy) will follow within the next days, some bugs need to be fixed")]),_c('li',[_vm._v("all components are now vuetify components. everything is 100% responsive, read more here: "),_c('a',{attrs:{"href":"https://vuetifyjs.com","target":"_blank"}},[_vm._v("vuetifyjs.com")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('br'),_vm._v("Git Repository: "),_c('a',{attrs:{"href":"https://github.com/german-in-austria/dioe-analyze/tree/master/dianalyze","target":"_blank"}},[_vm._v("https://github.com/german-in-austria/dioe-analyze/tree/master/dianalyze")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zXLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__ = __webpack_require__("paZo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f70e22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__ = __webpack_require__("TreG");
function injectStyle (ssrContext) {
  __webpack_require__("dijw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f70e22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fd7f48524cce9cf34c44.js